"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("path", {
    d: "M251 284.9l207.8-120v-19.1c0-23-18.7-41.7-41.7-41.7H83.8c-23 0-41.7 18.7-41.7 41.7v6.1l208.9 133z"
  }), (0, _core.jsx)("path", {
    d: "M260.9 327.3c-3.2 1.9-6.8 2.8-10.4 2.8-3.9 0-7.8-1.1-11.2-3.3L42.2 201.4v152.8c0 23 18.7 41.7 41.7 41.7h333.3c23 0 41.7-18.7 41.7-41.7V213l-198 114.3z"
  }));
};

exports.default = _default;